import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../../helpers/constants";
import { PAYMENT_STRINGS } from "./strings";
import { formatCLP } from "../../../helpers/functions";
import PurchaseAPI from "../../../services/api/purchase.api";
import SuccessIcon from "./success-icon";

const strings = PAYMENT_STRINGS.success;

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("es-CL", { day: "numeric", month: "long", year: "numeric" });

const ReceiptRow = ({ label, value, valueStyle }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: "1px solid #f5f5f5" }}>
    <span style={{ color: "#999", fontSize: 13 }}>{label}</span>
    <span style={{ fontWeight: 500, fontSize: 13, color: "#222", ...valueStyle }}>{value}</span>
  </div>
);

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");
  const paymentId = searchParams.get("paymentId");

  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(!!paymentId);

  useEffect(() => {
    if (!paymentId) return;
    PurchaseAPI.getPaymentDetails(paymentId)
      .then((res) => setPayment(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [paymentId]);

  const handleBack = () => {
    if (clientId) {
      navigate(`${ROUTES.CLIENTS.route}/${clientId}`);
    } else {
      navigate(ROUTES.CLIENTS.route);
    }
  };

  return (
    <div className="gm-clients-details-container">
      <div style={{ maxWidth: 440, margin: "40px auto", padding: "0 24px 32px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <SuccessIcon />
        {/* Title */}
        <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 6, textAlign: "center", color: "#1a1a1a" }}>{strings.title}</h2>

        {/* Subtitle */}
        {payment && (
          <p style={{ color: "#999", fontSize: 14, marginBottom: 32, textAlign: "center" }}>
            {strings.paidSubtitle} {formatCLP(payment.amount)}
          </p>
        )}
        {loading && <p style={{ color: "#999", marginBottom: 32 }}>Cargando detalles...</p>}
        {!payment && !loading && (
          <p style={{ color: "#999", fontSize: 14, marginBottom: 32, textAlign: "center" }}>{strings.description}</p>
        )}

        {/* Receipt card */}
        {payment && (
          <>
            <p style={{ alignSelf: "flex-start", fontWeight: 700, fontSize: 15, color: "#1a1a1a", marginBottom: 8 }}>{strings.detailsTitle}</p>
            <div style={{ width: "100%", background: "#fff", borderRadius: 16, padding: "0 20px", marginBottom: 32, boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
              <ReceiptRow label={strings.planLabel} value={payment.planName} />
              <ReceiptRow label={strings.testsLabel} value={`${payment.testsQuantity} tests`} />
              <ReceiptRow label={strings.dateLabel} value={formatDate(payment.createdAt)} />
              <ReceiptRow label={strings.amountLabel} value={formatCLP(payment.amount)} />
              <ReceiptRow
                label={strings.statusLabel}
                value={strings.statusSuccess}
                valueStyle={{ color: "#2d6a4f", fontWeight: 600 }}
              />
            </div>
          </>
        )}

        {/* Back button */}
        <button
          type="button"
          className="gm-primary-button"
          style={{ padding: "10px 16px", width: "100%", fontSize: 13 }}
          onClick={handleBack}
        >
          {strings.backButton}
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
